<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number;
    label?: string;
  }>(),
  {
    size: 18,
    label: undefined,
  },
);
</script>

<template>
  <svg
    class="app-icon"
    :width="size"
    :height="size"
    viewBox="0 0 250 219"
    fill="currentColor"
    :aria-hidden="label ? undefined : true"
    :aria-label="label"
    role="img"
  >
    <!-- Metric logomark, kept in sync with web/public/favicon.svg -->
    <g transform="translate(0.000000,219.000000) scale(0.100000,-0.100000)" stroke="none">
      <path
        d="M1882 1647 c-276 -276 -502 -504 -502 -507 0 -8 144 -150 152 -150 3 0 200 195 437 433 l432 432 -2 143 c-1 78 -5 145 -9 147 -3 2 -232 -222 -508 -498z"
      />
      <path
        d="M80 1972 l0 -138 153 -150 c751 -739 1284 -1257 1295 -1262 4 -1 40 31 80 71 l73 73 -73 69 c-40 38 -185 179 -323 314 -137 135 -347 340 -465 455 -118 116 -328 322 -465 458 -138 136 -256 248 -263 248 -9 0 -12 -37 -12 -138z"
      />
      <path
        d="M2027 1222 c-196 -196 -357 -360 -357 -364 0 -10 140 -143 151 -143 5 0 137 128 294 284 l285 284 0 143 c0 79 -4 145 -8 148 -5 3 -169 -156 -365 -352z"
      />
      <path
        d="M81 1401 l0 -139 427 -419 c647 -634 723 -708 730 -711 4 -1 40 31 80 71 l73 73 -113 109 c-62 60 -315 308 -563 550 -538 526 -619 605 -628 605 -3 0 -6 -63 -6 -139z"
      />
      <path
        d="M2102 727 l-282 -282 0 -155 0 -155 290 290 291 290 -2 142 c0 79 -4 145 -8 147 -4 3 -134 -122 -289 -277z"
      />
      <path
        d="M81 831 l1 -139 226 -224 c125 -124 256 -251 290 -284 l64 -59 -4 149 -3 149 -280 273 c-154 151 -283 274 -287 274 -4 0 -7 -62 -7 -139z"
      />
      <path
        d="M2219 274 l-164 -164 173 0 173 0 -2 160 c0 88 -4 162 -8 164 -4 3 -81 -69 -172 -160z"
      />
      <path
        d="M87 393 c-2 -5 -5 -70 -6 -145 l-2 -138 153 0 153 0 -145 145 c-80 80 -146 145 -147 145 -1 0 -4 -3 -6 -7z"
      />
    </g>
  </svg>
</template>
